import { IWellSpec, WellsSpec } from './wells-spec';

export interface IWellsDescription {
  mud_system?: string;
  well?: string;
}

export interface IWellsSpecifications {
  descriptions?: IWellsDescription;
  items?: IWellSpec[];
}

export class WellsSpecifications implements IWellsSpecifications {
  descriptions: IWellsDescription;
  items: WellsSpec[];

  constructor( wellsSpecs: IWellsSpecifications = {} ) {
    this.descriptions = wellsSpecs.descriptions || {};
    this.items = this.transformSpecs(wellsSpecs.items);
  }

  private transformSpecs( specs: IWellSpec[] = [] ): WellsSpec[] {
    if ( specs.length < 1 ) {
      return [ new WellsSpec() ];
    }
    return specs.map(( spec ) => new WellsSpec(spec));
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/cv/wells-specifications.ts